import { SmartCheckbox } from 'app/components/formik/Checkbox'
import { SmartRadio } from 'app/components/formik/Radio'
import { FormGroup } from 'app/components/shared/FormGroup'
import React from 'react'

export const Privacy: React.FC = () => {
  // const { values, setFieldValue } = useFormikContext<ProfileFormValues>()

  return (
    <>
      <FormGroup>
        <SmartCheckbox name='privacy_required'>
          Dichiaro di aver preso visione dell&apos; informativa privacy,
          selezionando il titolare al quale i dati sono forniti.
        </SmartCheckbox>
      </FormGroup>
      <FormGroup>
        <SmartRadio
          label='Presto il consenso per finalità di marketing diretto, mediante e-mail, sms, canali digitali, contatto telefonico con o senza operatore e/o posta ordinaria.'
          name='privacy_optional_internal_marketing'
          options={[
            { label: 'Sì', value: true },
            {
              label: 'No',
              value: false,
            },
          ]}
        />
      </FormGroup>
      <FormGroup>
        <SmartRadio
          label='Acconsento al trasferimento dei miei dati ad altre società del Gruppo e/o a soggetti terzi per autonome finalità di marketing diretto, mediante e-mail, sms, canali digitali, contatto telefonico e/o posta ordinaria.'
          name='privacy_optional_external_marketing'
          options={[
            { label: 'Sì', value: true },
            {
              label: 'No',
              value: false,
            },
          ]}
        />
      </FormGroup>
    </>
  )
}
